(function($) {
  'use strict';

  const events = {
    dom: function() {},

    data: {
      page: $('body').data('page')
    },

    anchorEvent: function() {
      const _ = this;

      $('a').click(function() {
        const $this = $(this);

        const section_type = $this.closest('[data-section]').data('section');
        const section_name = $this.closest('[data-section]').attr('aria-label');
        const record_id = $this.closest('[data-section]').attr('data-id');

        let text = $this.text().length ? $this.text() : false;
        const url = $this.attr('href');
        const num = $this.attr('data-num') ? $this.data('num') : false;

        if ( (!text || !text.length) && $this.attr('aria-label')) {
          text = $this.attr('aria-label');
        }

        const data = {
          'page': _.data.page,
          'section_type': section_type,
          'section_name': section_name,
          'record_id': record_id,
          'button_number': num,
          'button_text': text,
          'button_url': url
        };

        gtag('event', 'click', data);
      });
    },

    ready: function() {
      this.dom();
      this.anchorEvent();
    }
  };

  $(function() { events.ready(); });

})(jQuery);
